var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',_vm._g(_vm._b({attrs:{"disabled":_vm.loading,"error-messages":_vm.errorMessage,"hide-details":false,"loading":_vm.loading,"messages":_vm.message,"outlined":"","placeholder":" "}},'v-textarea',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }